import React from 'react';
import { PageSessionThreePlanoAnualProps } from './SessionAnaliseMunicipios';
import PageTemplatePlanoAnual from '../../templates/PageTemplatePlanoAnual';
import StyledGlobal from '../../../../PlanoAnual2025.styled';
import GridColumns from 'pages/ebooks/components/templates/GridColumns';
import Colors from 'enums/Colors';
import StyleDepoimentsHome from 'pages/home/components/homeV2/depoiments/DepoimentsHome.styled';
import styled from 'styled-components';
import { fetchStorageFile } from 'hooks/StoreFiles';
import { ConfigProvider, Image, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { RiDoubleQuotesL } from 'react-icons/ri';
import ResponsiveGrid from 'pages/ebooks/components/templates/ResponsiveGrid';

interface DataType {
    key: string;
    name: string;
    solucoes: string;
    // estudantes: string;
}

const dataSource: DataType[] = [
    {
        key: '1',
        name: 'Gestão Nota 10',
        solucoes: `
        O programa é voltado para o fortalecimento das lideranças educacionais e escolares,
        apoiando a atuação de diretores tecnicamente qualificados e preparados para garantir o
        alcance das metas de aprendizagem e a melhoria dos indicadores educacionais. 
        `,
        // estudantes: '27.000',
    },
    {
        key: '2',
        name: 'Circuito 360',
        solucoes: `
        O Programa tem como objetivo apoiar as secretarias de educação na
        formulação e gestão de políticas educacionais para os <strong>Anos Iniciais do
        Ensino Fundamental</strong>, com foco na perspectiva de educação integral.
        `,
        // estudantes: '16.000',
    },
    {
        key: '3',
        name: 'Se Liga',
        solucoes: `
            O programa é voltado para a alfabetização de estudantes com distorção
            idade-série matriculados do <strong>3º ao 5º ano do Ensino Fundamental.</strong>
        `,
        // estudantes: '32',
    },
    {
        key: '4',
        name: 'Acelera Brasil',
        solucoes: `
            O programa tem como objetivo reduzir a distorção idade-série por meio da
            aceleração do fluxo escolar de estudantes do <strong>3º ao 5º ano do Ensino Fundamental.</strong>
        `,
        // estudantes: '92',
    },
    {
        key: '5',
        name: 'Fórmula da Vitória',
        solucoes: `
        O programa tem como objetivo qualificar a aprendizagem em Língua Portuguesa
        de estudantes dos <strong>Anos Finais do Ensino Fundamental</strong>, contribuindo para
        reverter quadros de reprovação e exclusão no ambiente escolar.
        `,
        // estudantes: '20',
    },
];

const columns: ColumnsType<DataType> = [
    {
        title: 'SOLUÇÃO EDUCACIONAL ',
        dataIndex: 'name',
        key: 'name',
        align: 'center',
        render: (text: string) => <span style={{ fontWeight: 'bold' }}>{text}</span>,
    },
    {
        title: 'DESCRIÇÃO',
        dataIndex: 'solucoes',
        key: 'solucoes',
        align: 'center',
        render: (text: string) => (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: Colors.White,
                    padding: '20px',
                    borderRadius: 8,
                }}
            >
                <span style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: text }} />
            </div>
        ),
    },
    // {
    //     title: 'CRIANÇAS E JOVENS ATENDIDOS',
    //     dataIndex: 'estudantes',
    //     key: 'estudantes',
    //     align: 'center',
    //     render: (text: string) => (
    //         <div
    //             style={{
    //                 display: 'flex',
    //                 alignItems: 'center',
    //                 justifyContent: 'center',
    //                 backgroundColor: Colors.Yellow,
    //                 borderRadius: 8,
    //             }}
    //         >
    //             <span
    //                 style={{
    //                     fontWeight: 'bold',
    //                     color: Colors.White,
    //                     fontSize: '22px',
    //                     alignSelf: 'center',
    //                     justifySelf: 'center',
    //                 }}
    //             >
    //                 {text}
    //             </span>
    //         </div>
    //     ),
    // },
];

const Styled = {
    CardWhite: styled.div`
        background-color: white;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
    `,
    CardWhite2: styled.div`
        background-color: #f7f4f3;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;
    `,

    CardYellow: styled.div`
        background-color: #f1bc40;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        padding: 20px;
        font-size: 18px;
        line-height: 24px;
        width: 100%;
        color: ${Colors.White};
    `,
};

const PageThreeTwoPlanoAnual: React.FC<PageSessionThreePlanoAnualProps> = ({}) => {
    return (
        <>
            <PageTemplatePlanoAnual numberPage={21} stylesContent={{ marginRight: '80px' }}>
                <StyledGlobal.Title blue fontSize="32px">
                    3.2 MACAÉ
                </StyledGlobal.Title>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            O município de <strong>Macaé</strong>, situado na Região Norte do Rio de Janeiro, é uma cidade de médio porte com
                            aproximadamente <strong>264 mil habitantes.</strong> Sua economia é fortemente impulsionada pela indústria de
                            petróleo e gás, o que a consolida como um dos maiores pólos econômicos do estado, trazendo grandes oportunidades de
                            desenvolvimento econômico mas, também, desafios significativos de desigualdade social.
                            <br />
                            <br />
                            Reconhecendo os desafios locais de desigualdade, especialmente na educação, Macaé tem direcionado esforços para
                            aprimorar a qualidade de sua rede de ensino. Em 2025, essa iniciativa se fortaleceu com a parceria estabelecida com o
                            Instituto Ayrton Senna e a implementação do <strong>Plano Anual Instituto Ayrton Senna.</strong> O objetivo da
                            colaboração foi introduzir estratégias que permitam ao município enfrentar as dificuldades educacionais, assegurando
                            um aprendizado consistente e oportunidades mais equitativas para o desenvolvimento das crianças e jovens.
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.Title style={{ color: Colors.Blue }}>3.2.1 A EDUCAÇÃO NO MUNICÍPIO</StyledGlobal.Title>
                        <p>
                            Macaé apresenta um cenário educacional particular: embora a alfabetização e aprendizagem estejam acima das médias do
                            estado e do país, os indicadores de fluxo — distorção idade-série e taxa de reprovação — são significativamente
                            piores ao longo do Ensino Fundamental.
                        </p>
                        <StyledGlobal.TitleYellow>ACESSO</StyledGlobal.TitleYellow>
                        <Styled.CardWhite2>
                            <Image
                                width={'70%'}
                                src={fetchStorageFile('anexo_storage_files_14243969628686345306.png_2025-11-19-1763589095897.png')}
                                alt={`
                                    Quadro comparativo dos anos iniciais e finais do Ensino Fundamental, com ícones de escola, professor e matrícula. Nos anos iniciais: 45 escolas, 758 professores e 16.227 matrículas. 
                                    Nos anos finais: 22 escolas, 717 professores e 11.517 matrículas. 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                            <p style={{ fontSize: 14 }}>Fonte: MEC/Inep - Censo Escolar (2024). Rede Municipal.</p>
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={22} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr 1fr',
                        tablet: '1fr 1fr',
                        mobile: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.TitleYellow>ALFABETIZAÇÃO</StyledGlobal.TitleYellow>
                        <p>
                            Apesar da <strong>pequena queda ocorrida entre 2023 e 2024</strong> no percentual de estudantes alfabetizados(as) na
                            idade certa, um movimento diferente daquele observado no estado do Rio de Janeiro e no país, o percentual ainda
                            permanece <strong>superior às médias estadual e nacional.</strong>
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.TitleYellow>DISTORÇÃO IDADE-SÉRIE</StyledGlobal.TitleYellow>
                        <p>
                            <strong>O atraso escolar é um fenômeno educacional ainda expressivo no município.</strong> Nos anos iniciais do
                            Ensino Fundamental, 16,3% dos estudantes estavam com pelo menos 2 anos de atraso em 2024, superior à média no estado
                            do Rio de Janeiro e mais que o dobro da média nacional. Nos anos finais, o percentual de estudantes em atraso no
                            município também foi significativamente superior aos percentuais obtidos no estado e no país.
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.TitleYellow>APROVAÇÃO, REPROVAÇÃO E ABANDONO</StyledGlobal.TitleYellow>
                        <p>
                            Apesar do aumento nas <strong>taxas de aprovação</strong> no Ensino Fundamental ao longo dos últimos anos em Macaé,
                            elas ainda são
                            <strong>inferiores às observadas no estado do Rio de Janeiro e na média do país.</strong> Esse fenômeno ocorre pelas
                            taxas de reprovação relativamente altas no município. Em Macaé, mais de 10 estudantes a cada 100 reprovam nos anos
                            finais do Ensino Fundamental.{' '}
                        </p>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>

                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr 1fr',
                        notebook: '1fr 1fr 1fr',
                        mobile: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <Styled.CardWhite2>
                            <Image
                                src={fetchStorageFile('anexo_storage_files_6420970052671352974.png_2025-11-19-1763589901450.png')}
                                alt={`Gráfico de barras verticais comparando a taxa de alfabetização em Macaé. Em 2023, a barra azul escura indica 59,9%. Em 2024, a barra azul clara indica 59,5%. Uma seta destaca a leve redução. `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Styled.CardWhite2>
                            <Image
                                src={fetchStorageFile('anexo_storage_files_13459385079229690248.png_2025-11-19-1763590022599.png')}
                                alt={`Gráfico de barras comparando a distorção idade-série em 2024 para anos iniciais e anos finais. 
                                    Anos iniciais: Macaé 16,3%, Rio de Janeiro 15,1%, Brasil 8%. 
                                    Anos finais: Macaé 29,4%, Rio de Janeiro 24,1%, Brasil 20,8%. 
                                    Cada conjunto apresenta três barras coloridas — azul claro (Macaé), azul escuro (RJ) e amarelo (Brasil) `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        {' '}
                        <Styled.CardWhite2>
                            <Image
                                src={fetchStorageFile('anexo_storage_files_12545440836618293049.png_2025-11-19-1763591877872.png')}
                                alt={`
                                    Gráfico de barras empilhadas mostrando taxas de aprovação, reprovação e abandono em 2024, comparando Macaé, Rio de Janeiro e Brasil. Nos anos iniciais, aprovação: Macaé 92,8%, Rio de Janeiro 93,9%, Brasil 96,9%. 

                                    Reprovação: Macaé 6,9%, Rio de Janeiro 5,7%, Brasil 2,8%. 

                                    Abandono: Macaé 0,3%, Rio de Janeiro 0,4%, Brasil 0,3%. 

                                    Nos anos finais, aprovação: Macaé 87,8%, Rio de Janeiro 91,5%, Brasil 92%.  

                                    Reprovação: Macaé 11,1%, Rio de Janeiro 7,7%, Brasil 6,6%. 

                                    Abandono: Macaé 1,1%, Rio de Janeiro 0,8%, Brasil 1,4%. 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <p style={{ fontSize: 14 }}>Fontes: MEC - Indicador Criança Alfabetizada. MEC/Inep - Censo Escolar.</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={23} stylesContent={{ marginRight: '80px', marginLeft: '20px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 300px',
                        notebook: '1fr 300px',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                notebook: '1fr 300px',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <StyledGlobal.TitleYellow>APRENDIZADO ADEQUADO</StyledGlobal.TitleYellow>
                                <p>
                                    Em 2023,{' '}
                                    <strong>
                                        os resultados em termos de aprendizagem dos estudantes foram positivos frente àqueles observados na média
                                        do estado e no país.
                                    </strong>{' '}
                                    No 5º ano do Ensino Fundamental, 64% dos(as) estudantes apresentaram aprendizado adequado em Língua
                                    Portuguesa, quase 10 pontos percentuais acima da média nacional. No 9º ano, o percentual foi de 42,9%, também
                                    significativamente superior ao observado no país.
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <Styled.CardWhite2 style={{ padding: 0 }}>
                                    <Image
                                        style={{
                                            width: '100%',
                                        }}
                                        src={fetchStorageFile('anexo_storage_files_420382358544082267.png_2025-11-20-1763640260256.png')}
                                        alt={`
                                            Conjunto de ícones de crianças representando a proporção de aprendizado adequado em Língua Portuguesa no 5º ano e 9º ano do Ensino Fundamental. 
                                            5º ano: Macaé 64%, Rio de Janeiro 53,4%, Brasil 54,2%. 
                                            9º ano: Macaé 42,9%, Rio de Janeiro 38,3%, Brasil 33,6%. 
                                            Uma parte dos ícones são pintados de azul de acordo com o percentual de cada território, para indicar os estudantes com nível adequado; o restante dos ícones está em cinza. 
                                            `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </Styled.CardWhite2>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Image
                            height={660}
                            style={{ objectFit: 'cover' }}
                            src={fetchStorageFile('anexo_storage_files_18405283363634859904.webp_2025-11-20-1763639989552.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>

                <p style={{ fontSize: 14 }}>Fontes: MEC/Inep - Censo Escolar. MEC/Inep - SAEB. Rede Municipal.</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={24} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '480px 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.Title style={{ color: Colors.Blue }}>3.2.2 APRESENTAÇÃO DO PLANO ANUAL EM MACAÉ</StyledGlobal.Title>
                        <p>
                            No âmbito do Plano Anual Instituto Ayrton Senna, o município de Macaé implementou cinco soluções educacionais, para
                            ajudar a rede de ensino a lidar com os desafios de alfabetização, atraso escolar, defasagem de aprendizagens e gestão
                            escolar.
                        </p>

                        <StyledGlobal.CardBlue
                            style={{ maxWidth: '240px', marginTop: '80px', padding: '40px' }}
                            role="img"
                            aria-label="Quadro informativo apresentando o dado: mais de 29 mil professores e alunos da rede pública de ensino"
                        >
                            <div className="metrica">
                                <span> +29 mil </span> <p>professores e alunos da rede pública de ensino</p>
                            </div>
                        </StyledGlobal.CardBlue>

                        
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.TableWrapper>
                        <ConfigProvider
                            theme={{
                                token: {
                                    colorTextHeading: '#0e60e8',
                                    colorBgBase: '#eae8e6',
                                },
                            }}
                            table={{
                                style: {
                                    background: 'none',
                                },
                            }}
                        >
                            <Table pagination={false} dataSource={dataSource} columns={columns} scroll={{ x: 900 }} style={{ minWidth: 900 }} />
                        </ConfigProvider>
                    </StyledGlobal.TableWrapper>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>
                    Fontes: MEC/Inep - Censo Escolar (2024). Rede Municipal. Sistema de Monitoramento Instituto Ayrton Senna.
                </p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={25} stylesContent={{ marginRight: '80px' }}>
                <StyledGlobal.Title style={{ color: Colors.Blue, fontSize: '26px' }}>3.2.3 RESULTADOS</StyledGlobal.Title>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr 1fr 1fr',
                        tablet: '1fr 1fr',
                        mobile: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            A parceria entre Macaé e o Instituto Ayrton Senna em 2025 tem promovido{' '}
                            <strong>mudanças significativas na rede de educação municipal</strong>, com equipes técnicas relatando maior
                            segurança para lidar com os desafios do dia-a-dia e, sobretudo,
                            <strong>evidências de melhorias concretas na aprendizagem dos(as) estudantes.</strong>
                            <br />
                            <br />
                            Em 2025, no escopo dessa parceria, foram realizados{' '}
                            <strong>
                                11 cursos presenciais com técnicos(as) da secretaria de educação, diretores(as), coordenadores(as)
                                pedagógicos(as)
                            </strong>
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <p>
                            <strong>e professores(as)</strong>, a fim de preparálos(as) para implementar os diferentes programas educacionais no
                            município: Gestão Nota 10, Fórmula da Vitória, Circuito 360, Se Liga e Acelera Brasil. Além disso, foram
                            {' '} <strong>realizados 14 cursos virtuais,</strong> para que os(as) educadores(as) tivessem acesso
                            contínuo às formações.
                        </p>
                        <p>
                            Os(as) participantes avaliaram as formações de forma muito positiva, <br />
                            <strong style={{ fontSize: '24px' }}>alcançando um nível de satisfação médio de 86%.</strong>
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <p>
                            Além das formações sobre os programas educacionais, os(as) profissionais de educação contaram com apoio contínuo da
                            equipe do Instituto Ayrton Senna ao longo do ano.
                        </p>
                        <StyledGlobal.CardGray
                            style={{ maxWidth: '250px' }}
                            role="img"
                            aria-label="Foram realizadas 9 oficinas presenciais e 11 oficinas virtuais"
                        >
                            <span> Foram realizadas</span> <strong>9 oficinas presenciais e 11 oficinas virtuais</strong>
                        </StyledGlobal.CardGray>
                      
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Styled.CardYellow>
                            <RiDoubleQuotesL size={28} />

                            <p
                                dangerouslySetInnerHTML={{
                                    __html: `
                                                 O programa tem trazido
                                                reflexões, mas para além
                                                disso, tem trazido ações
                                                e acolhimento, já que
                                                quando deparamos com as
                                                dificuldades para implementálo, recebemos respostas
                                                imediatas e reais. O programa
                                                tem uma postura realista, que
                                                vem ao encontro das nossas
                                                limitações. Sempre nos
                                                trazendo acolhimento e ações
                                                objetivas para atender nossas
                                                demandas.”

                                <br />
                                <br />
                            <span style="font-weight: 300; font-size: 16px;">
                            Depoimento de um(a) <br />
                            participante dos cursos <br />
                            presenciais
                            </span>
                                `,
                                }}
                            />
                        </Styled.CardYellow>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <StyledGlobal.Content
                    style={{
                        alignItems: 'end',
                    }}
                >
                    <Image
                        height={300}
                        style={{ objectFit: 'cover' }}
                        src={fetchStorageFile('anexo_storage_files_15032774682930066807.webp_2025-11-20-1763642646112.webp')}
                        alt=""
                        preview={{
                            style: {
                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            },
                        }}
                    />
                    <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
                </StyledGlobal.Content>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={26} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Em Macaé, o acompanhamento dos resultados educacionais se fortaleceu com a{' '}
                                    <strong>criação e institucionalização de um Comitê Gestor,</strong> que organiza a governança e transforma a
                                    análise de dados em prática contínua, envolvendo todos os agentes na apropriação, responsabilização e busca
                                    de soluções para os desafios identificados. Esse comitê reúne o Secretário de Educação, equipes da Secretaria
                                    responsáveis pelos programas educacionais e especialistas do Instituto Ayrton Senna.
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Para que os dados orientem, de fato, as decisões da rede, é essencial dispor de informações que reflitam o
                                    cotidiano da sala de aula. Por isso, cada programa do município definiu com clareza quais dados coletar e
                                    quem deve acompanhá-los. Além disso, uma <strong>plataforma de monitoramento foi disponibilizada</strong>{' '}
                                    para concentrar e organizar essas informações, permitindo{' '}
                                    <strong>decisões ágeis e direcionadas ao desenvolvimento integral dos estudantes.</strong>
                                    <br />
                                    <br />O perfil dos(as) estudantes atendidos(as) variou de acordo com o programa implementado, como mostram os
                                    gráficos ao lado.
                                </p>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Styled.CardWhite style={{ padding: '20px' }}>
                            <h2 style={{ fontSize: '18px' }}>FAIXA ETÁRIA</h2>
                            <ResponsiveGrid
                                templates={{
                                    desktop: '1fr 1fr',
                                    notebook: '1fr 1fr',
                                    tablet: '1fr',
                                }}
                                styles={{ margin: 0, gap: '40px' }}
                            >
                                <StyledGlobal.ContentColumn>
                                    <Image
                                        src={fetchStorageFile('anexo_storage_files_1470621641278937370.png_2025-11-20-1763643325305.png')}
                                        alt={`Gráfico de pizza mostrando a distribuição por idade dos estudantes do Acelera Brasil: 10 anos (21,7%), 11 anos (42,4%), 12 anos (28,3%), 13 anos (6,5%) e 14 anos (1,1%). Cada fatia identifica a porcentagem por faixa etária. `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </StyledGlobal.ContentColumn>
                                <StyledGlobal.ContentColumn>
                                    <Image
                                        src={fetchStorageFile('anexo_storage_files_13672074641758079175.png_2025-11-20-1763643384175.png')}
                                        alt={`Gráfico de pizza representando distribuição de idades no programa Se Liga: 10 anos (40,6%), 11 anos (25%), 12 anos (21,9%), 13 anos (3,1%), 14 anos (6,3%) e 15 anos ou mais (3,1%). Cada fatia identifica a porcentagem por faixa etária. `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </StyledGlobal.ContentColumn>
                            </ResponsiveGrid>
                            <p>
                                Mais de 40% dos(as) alunos(as) das turmas do Acelera Brasil no município tinham 11 anos (equivalente ao sexto
                                ano, seguindo o fluxo esperado da educação básica), pouco mais de 20% tinham 10 anos, e mais de 35% tinham 12
                                anos ou mais, incluindo adolescentes de 14 anos, idade esperada para o último ano do Ensino Fundamental. <br />
                                <br /> No Se Liga, as turmas eram ainda mais diversas em relação à idade dos(as) estudantes, variando de 10 a 15
                                anos, e com uma prevalência maior de estudantes mais novos (mais de 40% com 10 anos).
                            </p>
                        </Styled.CardWhite>
                        <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={27} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                notebook: '1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <p>
                                    A participação nos programas já trouxe resultados expressivos do ponto de vista de aprendizado desses(as)
                                    estudantes. Em abril, início do programa,{' '}
                                    <strong>
                                        72% dos(as) alunos(as) das turmas do Se Liga estavam no nível mais baixo de Língua Portuguesa,
                                    </strong>{' '}
                                    com desempenho equivalente ao esperado para a Educação Infantil,{' '}
                                    <strong>percentual que chegou a zero em setembro.</strong> Além disso, no mesmo mês, quase metade da turma
                                    alcançou desempenho equivalente aos níveis mais altos da escala, indicando sucesso na consolidação da
                                    alfabetização plena.
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Os avanços também foram percebidos nas turmas do Acelera Brasil, em especial na escrita dos(as) estudantes.
                                    <strong>
                                        Apenas 12% escreviam palavras com sílabas complexas ortograficamente no início do programa; em setembro,
                                        quase 60% da turma já tinha conquistado essa competência.
                                    </strong>{' '}
                                    A fluência leitora também se tornou mais presente entre os(as) alunos(as), passando de 30% para 64%. Além
                                    disso, em relação à produção textual, apenas 2% dos(as) estudantes escreviam textos com frases ampliadas, com
                                    desenvolvimento lógico de ideias interligadas por conectivos em abril, percentual que chegou a 40% em
                                    setembro.
                                </p>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                        <StyledGlobal.Content>
                            <Image
                                width={'70%'}
                                height={400}
                                style={{ objectFit: 'cover', objectPosition: 'top' }}
                                src={fetchStorageFile('anexo_storage_files_10944812981137627465.webp_2025-11-20-1763644235927.webp')}
                                alt=""
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.Content>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Styled.CardWhite style={{ padding: '20px' }}>
                            <h2 style={{ fontSize: '18px' }}>NÍVEL EM LÍNGUA PORTUGUESA</h2>
                            <ResponsiveGrid
                                templates={{
                                    notebook: '1fr 1fr',
                                    tablet: '1fr',
                                }}
                                styles={{ margin: 0, gap: '40px' }}
                            >
                                <StyledGlobal.ContentColumn>
                                    <Image
                                        width={'100%'}
                                        src={fetchStorageFile('anexo_storage_files_14030514921391878898.png_2025-11-20-1763644110260.png')}
                                        alt={`Dois grupos de ícones em formato de círculo, com preenchimento em amarelo representando o percentual de estudantes no nível mais baixo em língua portuguesa. 
                                            Texto que acompanha o primeiro grupo diz: ‘Em abril, 72% dos estudantes do Se Liga estavam no nível mais baixo de Língua Portuguesa’ 
                                            Texto que acompanha o segundo grupo diz: ‘Em setembro, o percentual chegou a zero, ou seja, todos evoluíram de nível’ `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </StyledGlobal.ContentColumn>
                                <StyledGlobal.ContentColumn>
                                    <Image
                                        width={'100%'}
                                        src={fetchStorageFile('anexo_storage_files_6931610791771975015.png_2025-11-20-1763644158249.png')}
                                        alt={`
                                            Dois grupos de ícones em formato de círculo, com preenchimento em azul representando o percentual de estudantes do Acelera Brasil que escrevem palavras com sílabas complexas.  
                                            Texto que acompanha o primeiro grupo diz: ‘No início do programa, apenas 12% escreviam palavras com sílabas complexas’ 
                                            Texto que acompanha o segundo grupo diz: ‘Em setembro, 60% já tinha conquistado essa competência’ 
                                            `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </StyledGlobal.ContentColumn>
                            </ResponsiveGrid>
                        </Styled.CardWhite>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={28} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            Os resultados evidenciam que os programas são{' '}
                            <strong>efetivos para impulsionar a alfabetização e o aprendizado,</strong> criando condições para que estudantes com
                            maiores desafios avancem com mais segurança e autonomia em sua trajetória, ampliando as chances de{' '}
                            <strong>concluir a educação básica e exercer plenamente a cidadania.</strong>
                            <br />
                            <br />O sucesso dos programas apresentado anteriormente foi potencializado{' '}
                            <strong>pela distribuição de livros para os(as) estudantes.</strong> Em 2025, foram mais de 5 mil livros
                            distribuídos, sendo <strong>1.965 livros pedagógicos e 3.130 livros de literatura infanto-juvenil,</strong> incluindo
                            exemplares com conteúdo adaptado, garantindo acessibilidade física, visual e cognitiva.
                        </p>
                        <Styled.CardWhite2 style={{}}>
                            <Image
                                src={fetchStorageFile('anexo_storage_files_5670780396846056200.png_2025-11-20-1763644798846.png')}
                                alt={`Quadro com quatro ícones de livros indicando o número de exemplares distribuídos por programa e o número de exemplares de livros de literatura. 
                                    Acelera Brasil: 531 livros; Se Liga: 149 livros; Fórmula da Vitória: 1.285 livros; Livros de Literatura: 3.130 livros `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Styled.CardWhite2 style={{ padding: '20px', gap: '40px' }}>
                            <h2 style={{ fontSize: '18px' }}>EXEMPLOS DOS LIVROS DE LITERATURA DISTRIBUÍDOS</h2>
                            <Image
                                src={fetchStorageFile('anexo_storage_files_8957875119414717438.png_2025-11-20-1763644734658.png')}
                                alt=""
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={29} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            Um desdobramento concreto e mensurado pelas estratégias de monitoramento é{' '}
                            <strong>o aumento considerável da prática leitora</strong> pelos(as) estudantes atendidos pelos programas. No Acelera
                            Brasil, a média de livros lidos por estudante passou de 1,6 para 4,7, um aumento de quase três vezes. No Se Liga,
                            onde a frequência de leitura era menor, o aumento foi ainda mais considerável, passando de 0,8 para 4,1 livros por
                            aluno.
                        </p>
                        <Styled.CardWhite2>
                            <Image
                                width={'70%'}
                                src={fetchStorageFile('anexo_storage_files_14703136555403181453.png_2025-11-20-1763645267054.png')}
                                alt={`
                                    Conjunto de ícones de livros para comparar a média de livros lidos por estudante antes e depois da participação nos programas. No Se Liga: o número de livros lidos aumentou de 0,8 para 4,1 livros por estudante, com seta indicando ‘5 vezes mais’.” 
                                    No Acelera Brasil: o número de livros lidos aumentou de 1,6 para 4,7 livros por estudante, representado por ícones de livros e seta indicando crescimento de ‘3 vezes mais’. 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <p>
                            Além dos efeitos sobre a alfabetização e aumento da proficiência, a prática da leitura, potencializada pelo acesso à
                            um acervo diversificado amplia o{' '}
                            <strong>repertório cultural, contribuindo ainda mais para o desenvolvimento integral dessas crianças.</strong>
                        </p>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Como parte do programa <strong>Fórmula da Vitória,</strong> estudantes que vivenciavam defasagens em sua
                                    trajetória escolar foram convidados a reencontrar o poder da palavra e o prazer de aprender por meio da
                                    poesia. Dessa experiência nasceu um livro que reúne poemas criados nas salas de aula e que será distribuído
                                    às escolas do município — ao todo, <strong>2 mil exemplares serão impressos.</strong> Mais do que um
                                    resultado pedagógico, essa coletânea celebra o talento e a superação de cada estudante, reafirmando a escola
                                    como um espaço de desenvolvimento integral, de cultura e de encantamento com o conhecimento.
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <Styled.CardWhite2>
                                    <Image
                                        width={'100%'}
                                        src={fetchStorageFile('anexo_storage_files_16313252449932897447.png_2025-11-20-1763645406821.png')}
                                        alt=""
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </Styled.CardWhite2>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={30} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr 1fr',
                        notebook: '1fr 1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            No âmbito do programa <strong>Acelera Brasil</strong>, foi produzido um <strong>curta-metragem</strong> que reúne e
                            dá forma às experiências vividas pelos estudantes em atividades voltadas à valorização do patrimônio cultural local.
                            A obra registra os aprendizados construídos ao longo do percurso, em que os alunos foram convidados a conhecer e se
                            reconhecer na riqueza de sua própria história e identidade. Esse processo fortaleceu o sentimento de pertencimento e
                            despertou o orgulho pela comunidade, promovendo a valorização do patrimônio cultural como parte essencial de quem são
                            e do lugar onde vivem.
                        </p>
                        <p>
                            As soluções implementadas pelo Instituto Ayrton Senna foram avaliadas de maneira bem positiva pela equipe central na
                            Secretaria de Educação, com uma <strong>satisfação média de 79%</strong>. O aspecto mais bem avaliado foi o{' '}
                            <strong>apoio prestado pela equipe do Instituto (89%)</strong>. Como ponto de aprimoramento, destacase a plataforma
                            de monitoramento, com 50% de satisfação reportada pelas pessoas respondentes.{' '}
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Image
                            height={720}
                            style={{ objectFit: 'cover' }}
                            src={fetchStorageFile('anexo_storage_files_445408004995428264.webp_2025-11-20-1763645779116.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.TitleYellow>HISTÓRIAS DE SUPERAÇÃO</StyledGlobal.TitleYellow>
                        <p>
                            O aluno, no 5º ano, chegou ao Se Liga sem ler nem escrever e apresentava comportamento difícil, com desrespeito a
                            colegas e professores e rejeição à ajuda.
                        </p>
                        <p>
                            Ao longo do ano, a professora regente e a professora integradora trabalharam com{' '}
                            <strong>reforço positivo e controle emocional.</strong> Quando o estudante tinha atitudes agressivas ou
                            desrespeitosas, a professora aguardava que ele se acalmasse para conversar. Com isso, percebeu que ele era um bom
                            menino, com grande potencial, e passou a mostrar isso a ele.
                        </p>
                        <p>
                            Foi necessário primeiro fazê-lo <strong>gostar de ler.</strong> Com insistência, elogios e apoio da turma — que
                            comemorava cada avanço — ele passou a acreditar que era capaz.
                        </p>
                        <p>
                            Hoje, o aluno <strong>lê pequenos textos com interpretação, escreve frases</strong> respeitando o espaço entre as
                            palavras e, embora ainda precise de intervenção na ortografia, apresenta evolução constante.
                        </p>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
            </PageTemplatePlanoAnual>
        </>
    );
};

export default PageThreeTwoPlanoAnual;
